var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn-subscription",attrs:{"color":"primary","dark":"","to":_vm.link}},[_vm._v(" "+_vm._s(_vm.campaign_name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }